/**
 * 답장·전달 접두사를 걷어낸 제목.
 *
 * "Re: Re: RE: 9월 워크숍" 과 "9월 워크숍" 은 같은 이야기다. 이걸 구분하면
 * 방 안에서 답장이 오갈 때마다 "다른 이야기" 구분선이 뜬다.
 * 접두사가 여러 번 겹칠 수 있으므로 더 이상 벗겨지지 않을 때까지 반복한다.
 */
const REPLY_PREFIX =
  /^\s*(?:re|rep|ref|aw|antw|sv|vs|res|답장|회신|답신|fw|fwd|fwds|forward|전달|转发)\s*(?:\[\d+\])?\s*[:：]\s*/i;

export function normalizeSubject(raw: string): string {
  let subject = raw.trim();

  // 접두사가 겹쳐 붙은 만큼 벗긴다. 상한을 둬서 이상한 입력에도 멈추게 한다.
  for (let i = 0; i < 12; i += 1) {
    const stripped = subject.replace(REPLY_PREFIX, "");
    if (stripped === subject) break;
    subject = stripped;
  }

  return subject.trim();
}

/** 두 제목이 같은 이야기인가 */
export function isSameSubject(a: string, b: string): boolean {
  return normalizeSubject(a) === normalizeSubject(b);
}

/** 답장 보낼 때 붙일 제목. 이미 Re:가 있으면 더 붙이지 않는다. */
export function replySubjectFor(raw: string): string {
  const base = normalizeSubject(raw);
  return base.length === 0 ? "(제목 없음)" : `Re: ${base}`;
}
